//import React from "react";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
//import { injectStripe } from "react-stripe-elements";
//import RefreshStripeMutation from "./RefreshStripeMutation";

const SetStripePlanMutation = gql`
  mutation SetStripePlanMutation(
    $planId: Int
    $tokenId: String
    $vatNumber: String
    $cancel: Boolean = false
  ) {
    setStripePlan(
      input: {
        planId: $planId
        tokenId: $tokenId
        vatNumber: $vatNumber
        cancel: $cancel
      }
    ) {
      stripeInvoice {
        id
        amountDue
        amountPaid
        currency
        created
        status
        paymentIntentStatus
        paymentIntentClientSecret
      }
      user {
        nodeId
        userPlansByUserUuid(first: 50) {
          nodes {
            nodeId
            active
            planId
            lastChecked
            createdAt
            updatedAt
          }
        }
      }
    }
  }
`;

export default SetStripePlanMutation;

/*
const MyComponent = injectStripe(
  graphql(SetStripePlanMutation, {
    props({ mutate }) {
      return {
        setStripePlan: mutate,
      };
    },
  })(({ component: Component, props, setStripePlan }) => {
    return (
      <RefreshStripeMutation>
        {refreshStripe => {
          const mySetStripePlan = ({ token, variables }) => {
            let error;
            let result;
            return setStripePlan({ variables })
              .then(
                ok => {
                  console.log("OK");
                  result = ok;
                  const ssp = result.data.setStripePlan;
                  const invoice = ssp && ssp.stripeInvoice;
                  if (
                    invoice &&
                    (invoice.paymentIntentStatus === "requires_action" ||
                      invoice.paymentIntentStatus ===
                        "requires_payment_method") &&
                    invoice.paymentIntentClientSecret
                  ) {
                    console.log("Stripe intent secret");
                    return props.stripe.handleCardPayment(
                      invoice.paymentIntentClientSecret,
                      token
                    );
                  }
                  return null;
                },
                bad => {
                  error = bad;
                }
              )
              .then(refreshStripe)
              .then(() => {}, () => {}) // Finally
              .then(() => {
                console.log("done");
                if (error) {
                  return Promise.reject(error);
                } else {
                  return Promise.resolve(result);
                }
              });
          };
          return <Component {...props} setStripePlan={mySetStripePlan} />;
        }}
      </RefreshStripeMutation>
    );
  })
);

export const withSetStripePlan = component => props => (
  <MyComponent component={component} props={props} />
);
*/

export const withSetStripePlan = graphql(SetStripePlanMutation, {
  props({ mutate }) {
    return {
      setStripePlan: mutate,
    };
  },
});
